import { render, staticRenderFns } from "./userDeliveryGarbageList.vue?vue&type=template&id=255e706c"
import script from "./userDeliveryGarbageList.vue?vue&type=script&lang=js"
export * from "./userDeliveryGarbageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports